{
	"app_fallbacks": {
		"error": {
			"description": "An unexpected error occurred while rendering this page. You can try again, or head back to a working area of the app.",
			"title": "Something went wrong."
		},
		"go_back": "Go back",
		"go_home": "Go home",
		"loading": "Loading",
		"not_found": {
			"description": "The page you're looking for doesn't exist or may have moved. Head back to a working area of the app.",
			"title": "Page not found."
		},
		"permission_error": {
			"description": "You don't have the permissions to access this page.",
			"title": "Access denied"
		},
		"try_again": "Try again"
	},
	"app_sidebar": {
		"back_to_drive": "Back to Drive",
		"brand_logo_alt": "{{product}} logo",
		"drive": "Drive",
		"menu": {
			"logout": "Log out"
		},
		"storage": {
			"available": "{{available}} still available",
			"full": "No space left",
			"label": "Storage used",
			"organization_full": "Your organization is out of space",
			"title": "Storage",
			"used": "Using <b>{{used}}</b>",
			"used_of": "Using <b>{{used}}</b> of <b>{{quota}}</b>"
		},
		"user_menu": {
			"open": "Open user menu"
		}
	}
}
